import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui'
import { EUserProfileRoute } from '@/types'
import { createRouterLink } from '@/utils/url'
import { FundingBannerResult } from '../FundingBannerResult'
import { messages } from './messages'
import type { TFundingBannerSuccessProps } from './types'
import './styles.scss'

export const FundingBannerSuccess = ({ fundingRequestId, onResetStep }: TFundingBannerSuccessProps) => {
  const requestLink = createRouterLink(EUserProfileRoute.fundingRequest, { id: String(fundingRequestId) })

  return (
    <FundingBannerResult
      glassMorphIcon="success"
      title={messages.title}
      subTitle={messages.subTitle}
      buttons={
        <>
          <Button className="fundingBannerSuccess__button" onClick={onResetStep} modifiers={['outline-gray']}>
            {messages.buttons.close}
          </Button>
          <Link className="fundingBannerSuccess__button" to={requestLink}>
            <Button modifiers={['green']} isFake>
              {messages.buttons.goToRequest}
            </Button>
          </Link>
        </>
      }
    />
  )
}
